import React, { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import { SpiralSpinner, StageSpinner } from "react-spinners-kit";
import { ClipLoader, PropagateLoader, PuffLoader, PulseLoader } from "react-spinners";
import withLayout from "../../layouts/withLayout";
import UserHeader from "../../layouts/common/header";
// import pgbanner from "../../assets/images/page-banner/about-us-01-hero-bg.jpg"
import pgbanner from "../../assets/images/craft.jpg"
import serve1 from "../../assets/images/courses/370/course-1.jpg"
import $ from "jquery"
import UserLayout from "../../layouts/common";
import { Descriptions } from "antd";


const Services = () => {
const [expanded, setExpanded] = useState(false)
  
const services = [
    {
       

        id: 1,
        title: "FOR BUSINESSES",
        description: "Web-Design, Programming, Video Surviellance, Software Development, DataNetworking, Data Recovery, Repairs, POS Systems, Installations, Upgrades, Terminals/AP, Servers.Contact Us for needs.",
        icon: <i className="fa-solid fa-people-group" />
    },
    {
        id: 2,
        title: "SOFTWARE UPGRADES",
        description: "Need to Upgrade your unit to the latest Operating System or need New Software installed? Upgrades start at just $75",
        icon: <i className="fa-solid fa-globe" />
    },
    {
        id: 3,
        title: "REPAIRS",
        description: "Damaged Hardware or Software configuration? We can fix it. Repairs start at just $50.",
        icon: <i className="fa-solid fa-chart-line" />
    },
    {
        id: 4,
        title: "COMPUTER NETWORKING",
        description: "Need to communicate between computers in your Home or Office? Want to remote access your computers from anywhere. We have the Networking Solutions you need. Starting at just $75",
        icon: <i className="fa-solid fa-chart-line" />
    },
    {
        id: 5,
        title: "COMPUTER SERVICING",
        description: "We specialize in Windows, OSX and Linux. MAC or PC we service any and all issues. Starting at just $50- $99.",
        icon: <i className="fa-solid fa-chart-line" />
    },
    {
        id: 6,
        title: "MOBILE DEVICES",
        description: "Upgrades, Downloads, Data Recovery, Data Transfer, Password Unlock and more. Starting at just $50.",
        icon: <i className="fa-solid fa-chart-line" />
    },
    
]

    const closeAll = () => {
        $(".service-card-details-block").slideUp("fast"); // Use slideUp for smooth hiding
    };
    useEffect(() => {
        setTimeout(() => {
            $("#preloader").delay(450).fadeOut('slow');
        }, 2000);
    }, [])

    return (
        <div>

            <div id="preloader">
                <div className="">
                    <PulseLoader color="#2075d6"/>
                </div>
            </div>


            <div>
                <div className="page-banner-section section head-bann" style={{ backgroundImage: `url(${pgbanner})`, justifyContent:"center" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-banner-title">
                                    <h1 className="title text-left gilroy-800">Our Services</h1>
                                    <p className="gilroy-600 text-left text-white" style={{ fontSize: "19px", textTransform:"capitalize" }}>COMMERCIAL AND RESIDENTIAL IT SERVICES.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



        
            </div>
<div>
  {/* Page Title Section Start */}
  <div className="page-title-section section">
    <div className="page-title">
      <div className="container">
        {/* <h1 className="title">Courses Grid 02</h1> */}
      </div>
    </div>
    {/* <div className="page-breadcrumb">
      <div className="container">
        <ul className="breadcrumb">
          <li><a href="index.html">Home</a></li>
          <li className="current">Courses Grid 02</li>
        </ul>
      </div>
    </div> */}
  </div>
  {/* Page Title Section End */}
  {/* Course Section Start */}
  <div className="section section-padding-bottom">
    <div className="container">
     <div>
                        <section id="advertisers" className="advertisers-service-sec  pb-5">
  <div className="container">
    {/* <div className="row">
      <div className="section-header text-center">
        <h2 className="fw-bold fs-1">
          Our
          <span className="b-class-secondary">Advertiser </span>Services
        </h2>
        <p className="sec-icon"><i className="fa-solid fa-gear" /></p>
      </div>
    </div> */}
    <div className="row row-cols-1 row-cols-sm-1 row-cols-md-3 justify-content-center">
     {services.map((x, i) => {
        return(
            <div className="col">
                <div className="service-card">
                    <div className="icon-wrapper">
                        {x?.icon}
                        {/* <i className="fa-solid fa-chart-line" /> */}
                    </div>
                    <h3>{x?.title}</h3>
                    <p>
                        {x?.description}
                    </p>
                </div>
            </div>
        )
     })}
      {/* <div className="col">
        <div className="service-card">
          <div className="icon-wrapper">
            <i className="fa-solid fa-arrows-down-to-people" />
          </div>
          <h3>Advanced Targeting solution</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Quisquam consequatur necessitatibus eaque.
          </p>
        </div>
      </div>
      <div className="col">
        <div className="service-card">
          <div className="icon-wrapper">
            <i className="fa-solid fa-globe" />
          </div>
          <h3>Global Reach &amp; Quality Traffic</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Quisquam consequatur necessitatibus eaque.
          </p>
        </div>
      </div>
      <div className="col">
        <div className="service-card">
          <div className="icon-wrapper">
            <i className="fa-solid fa-money-check-dollar" />
          </div>
          <h3>Flexible pricing models</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Quisquam consequatur necessitatibus eaque.
          </p>
        </div>
      </div>
      <div className="col">
        <div className="service-card">
          <div className="icon-wrapper">
            <i className="fa-regular fa-circle-check" />
          </div>
          <h3>Advanced optimization technologies &amp; methodologies</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Quisquam consequatur necessitatibus eaque.
          </p>
        </div>
      </div>
      <div className="col">
        <div className="service-card">
          <div className="icon-wrapper">
            <i className="fa-solid fa-people-group" />
          </div>
          <h3>Dedicated account management team</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Quisquam consequatur necessitatibus eaque.
          </p>
        </div>
      </div> */}
    </div>
  </div>
</section>

</div>

    
      {/* <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 max-mb-n30">
        <div className="col max-mb-30" data-aos="fade-up">
          <div className="course-2">
            <div className="thumbnail">
                                        <a href="course-details-standard-sidebar.html" className="image"><img src={serve1} alt="Course Image" /></a>
            </div>
            <div className="info">
              <span className="price">$40</span>
              <span className="date">Jan 15, 2020</span>
              <h3 className="title"><a href="course-details-standard-sidebar.html">Learning to Write as a Professional Author</a></h3>
              <ul className="meta">
                <li><i className="far fa-file-alt" />20 Lessons</li>
                <li><i className="far fa-user-alt" />51 Students</li>
              </ul>
            </div>
          </div>
        </div>
      
   
      </div> */}
    
    </div>
  </div>
</div>


        </div>

    )
}

export default withLayout(UserLayout)(Services);